import { render, staticRenderFns } from "./Airlines.vue?vue&type=template&id=86a0a4ca&"
import script from "./Airlines.vue?vue&type=script&lang=js&"
export * from "./Airlines.vue?vue&type=script&lang=js&"
import style0 from "./Airlines.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports